module.exports = __webpack_public_path__ + "img/24.0e2cdc54.svg";